import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLD from "@/components/base/JsonLD";
import { dlaFirmSchema } from "@/components/base/PageSchemas";
import Breadcrumb from "@/components/base/Breadcrumb";

const bizServices = [
  {
    icon: "ri-building-line",
    title: "Kredyty inwestycyjne",
    desc: "Finansowanie zakupu maszyn, urządzeń, budynków i innych inwestycji rozwojowych. Pomagam dobrać optymalne warunki spłaty i zabezpieczenia.",
  },
  {
    icon: "ri-exchange-dollar-line",
    title: "Kredyty obrotowe",
    desc: "Elastyczne finansowanie bieżącej działalności firmy – na zakup materiałów, zapłatę za faktury i zapewnienie płynności finansowej.",
  },
  {
    icon: "ri-truck-line",
    title: "Leasing",
    desc: "Leasing operacyjny i finansowy dla firm – samochody, maszyny, sprzęt IT. Analiza, wybór oferty i kompletowanie dokumentacji.",
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "Refinansowanie firmowe",
    desc: "Przejście na korzystniejsze warunki spłaty istniejących zobowiązań kredytowych przedsiębiorstwa – niższe koszty, lepsza struktura.",
  },
  {
    icon: "ri-hand-coin-line",
    title: "Kredyty na start",
    desc: "Finansowanie dla nowych firm i startupów – wsparcie przy wnioskach o preferencyjne kredyty z programów wsparcia przedsiębiorczości.",
  },
  {
    icon: "ri-file-shield-line",
    title: "Gwarancje bankowe",
    desc: "Pomoc w uzyskaniu gwarancji bankowych niezbędnych przy przetargach, kontraktach handlowych i realizacji projektów.",
  },
];

export default function DlaFirmPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={dlaFirmSchema} />
      <Navbar />
      <main>
        <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
          <div className="mx-auto max-w-[1440px] px-4 text-center md:px-8 lg:px-16 xl:px-20">
            <Breadcrumb />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-3 block">Dla firm</span>
            <h1 className="mx-auto max-w-3xl font-heading text-3xl text-foreground-950 md:text-4xl lg:text-5xl">
              Finansowanie dla przedsiębiorców
            </h1>
          </div>
        </section>

        <section className="pb-16 md:pb-24">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <p className="mx-auto mb-10 max-w-3xl text-center text-base leading-relaxed text-foreground-600 md:mb-14">
              Oferuję kompleksowe wsparcie finansowe dla firm małych, średnich i dużych. Analizuję sytuację przedsiębiorstwa, przygotowuję dokumentację i negocjuję najlepsze warunki z instytucjami finansowymi.
            </p>

            <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-5 md:grid-cols-2 md:gap-6 lg:grid-cols-3">
              {bizServices.map((s) => (
                <div key={s.title} className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/60 hover:shadow-md transition-all">
                  <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 mb-5">
                    <i className={`${s.icon} text-2xl text-accent-500`} />
                  </div>
                  <h2 className="font-heading text-lg font-semibold text-foreground-950 mb-3">{s.title}</h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
